import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-mountain-icon',
  templateUrl: './mountain.component.html'
})
export class MountainComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
